export const getTopAdHeight = state => state.topAd.topAdHeight



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/topAd/topAd.selectors.js